import type { MarketplaceItem } from "../types";
import { AlertTriangle } from "lucide-react";
import { useLocale } from "../../../context/LanguageContext";

interface DeactivateConfirmDialogProps {
  item: MarketplaceItem;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export function DeactivateConfirmDialog({
  item,
  onConfirm,
  onCancel,
  loading,
}: DeactivateConfirmDialogProps) {
  const { t } = useLocale();
  return (
    <>
      <div className="fixed inset-0 z-50 bg-black/40" onClick={onCancel} />
      <div className="fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border border-border bg-card p-6 shadow-xl">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-destructive/10 p-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground">
              {t("rewards.deactivateDialog.title")}
            </h3>
            <p className="mt-1 text-sm text-muted-foreground">
              {t("rewards.deactivateDialog.message", { name: item.name })}
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="h-9 rounded-md px-4 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="h-9 rounded-md bg-destructive px-4 text-sm font-medium text-destructive-foreground hover:bg-destructive/90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? t("rewards.deactivateDialog.deactivating") : t("rewards.deactivate")}
          </button>
        </div>
      </div>
    </>
  );
}
